export default [
  {
    "Title": "All creatures of our God and king",
    "Key words": "praise",
    "Themes": "Praise,All creation praises",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise, call to worship",
    "Writer": "St Francis, trad. /Crowder",
    "Source": "Hymn",
    "Year": "C12th,17th",
    "Ideal Key(s)*": "Bb,B,C",
    "Tempo": 112,
    "Time signature": "6/4,4/4",
    "Range": 8,
    "Structure": "V1,3,5,7",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "All I have is Christ",
    "Key words": "sin,faith,atonement,obedience",
    "Themes": "Sin,faith atonement,obedience",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Expression of faith and obedience",
    "Writer": "J Kauflin",
    "Source": "Sovereign Grae",
    "Year": 2008,
    "Ideal Key(s)*": "C",
    "Tempo": 76,
    "Time signature": "3/4",
    "Range": 10,
    "Structure": "VCVCVC",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Amazing Grace/",
    "Key words": "grace,fear,journey",
    "Themes": "grace,fear,journey",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Assurance",
    "Writer": "Newton,trad",
    "Source": "Hymn",
    "Year": "1700s",
    "Ideal Key(s)*": "E,F",
    "Tempo": 92,
    "Time signature": "¾,4/4",
    "Range": 8,
    "Structure": "V1-4",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Ancient of Days",
    "Key words": "kingdom,worship",
    "Themes": "Kingdom,worship of whole earth",
    "Function": "Declaration",
    "Function/Emotion": "D: Declaration of worship",
    "Writer": "Sadler, Harvill",
    "Source": "Integrity",
    "Year": 1992,
    "Ideal Key(s)*": "Bb",
    "Tempo": 88,
    "Time signature": "4/4",
    "Range": 10,
    "Structure": "VCVCBC",
    "Style": "Upbeat,Retro",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Range",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "And can it be",
    "Key words": "gospel,freedom,righteousness",
    "Themes": "gospel,freedom,righteousness",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Assurance, boldness",
    "Writer": "Wesley, Campbell",
    "Source": "Hymn",
    "Year": 1738,
    "Ideal Key(s)*": "F",
    "Tempo": 144,
    "Time signature": "4/4",
    "Range": 10,
    "Structure": "V1,3,4,5",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone,God",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Awesome God",
    "Key words": "king,love",
    "Themes": "God reigns with wisdom,power,love",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Good add-on to another song",
    "Writer": "Mullins",
    "Source": "",
    "Year": 1988,
    "Ideal Key(s)*": "E,F,G",
    "Tempo": 66,
    "Time signature": "4/4",
    "Range": 6,
    "Structure": "C",
    "Style": "Simple",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Be still my soul",
    "Key words": "grief,trust,guidance,sovereignty",
    "Themes": "grief,trust,guidance,sovereignty",
    "Function": "Response,Preparation",
    "Function/Emotion": "P/R: Comfort",
    "Writer": "Schlegel, Sibelius",
    "Source": "Hymn",
    "Year": "1800s",
    "Ideal Key(s)*": "D,Eb",
    "Tempo": 92,
    "Time signature": "4/4",
    "Range": 6,
    "Structure": "V1-4",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Self",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Be thou my vision",
    "Key words": "vision,wisdom,wealth,victory,shelter",
    "Themes": "vision,wisdom,wealth,victory,shelter",
    "Function": "Response",
    "Function/Emotion": "R: (Pledge)",
    "Writer": "Trad.",
    "Source": "Hymn",
    "Year": "1800s",
    "Ideal Key(s)*": "D",
    "Tempo": 92,
    "Time signature": "3/4",
    "Range": 11,
    "Structure": "V1-5",
    "Style": "Celtic",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Before the throne",
    "Key words": "grace,atonement,election,judgment,resurrection",
    "Themes": "grace,atonement,election,judgment,resurrection",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Thankfulness for forgiveness, joy in assurance",
    "Writer": "Bancroft, Cook",
    "Source": "Sovereign Grae",
    "Year": 1997,
    "Ideal Key(s)*": "C,D",
    "Tempo": 76,
    "Time signature": "3/4",
    "Range": 12,
    "Structure": "VVV",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Range",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Behold our God",
    "Key words": "creator,king,redemption",
    "Themes": "God alone as creator,ruler and redeemer",
    "Function": "Declaration",
    "Function/Emotion": "D: Characteristics of God",
    "Writer": "Baird, Altrogge",
    "Source": "Sovereign Grae",
    "Year": 2011,
    "Ideal Key(s)*": "C",
    "Tempo": 73,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VCVCVC(BC)",
    "Style": "Slow,Uplifting",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone,Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Bless the Lord",
    "Key words": "worship,God’s goodness,eternity",
    "Themes": "worship,God’s goodness,eternity",
    "Function": "Declaration",
    "Function/Emotion": "D: Worship",
    "Writer": "Myrin, Redman",
    "Source": "WT",
    "Year": 2011,
    "Ideal Key(s)*": "D",
    "Tempo": 80,
    "Time signature": "4/4",
    "Range": 10,
    "Structure": "CVCVCVC",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Range",
    "Addressed to": "Self,God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Blessed be your name",
    "Key words": "suffering,blessing,worship,faithfulness",
    "Themes": "Suffering,blessing,worship,faithfulness",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Worship in blessings and suffering",
    "Writer": "Redman",
    "Source": "Thankyou",
    "Year": 2002,
    "Ideal Key(s)*": "G",
    "Tempo": 116,
    "Time signature": "4/4",
    "Range": 10,
    "Structure": "VVCVVCBC",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm,Range",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Christ is mine forevermore",
    "Key words": "walking with Christ,guidance,suffering,reward",
    "Themes": "Walking with Christ,guidance,suffering,reward",
    "Function": "Response",
    "Function/Emotion": "R: Comfort, assurance in walk with Christ",
    "Writer": "Robinson, Thompson",
    "Source": "City Alight",
    "Year": 2016,
    "Ideal Key(s)*": "Bb",
    "Tempo": 72,
    "Time signature": "3/4",
    "Range": 9,
    "Structure": "VVVB",
    "Style": "Modern hymn",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "City on a hill",
    "Key words": "Beatitudes,salt and light,kingdom,Spirit,humility",
    "Themes": "Beatitudes,salt and light,Kingdom,Spirit,humility",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: God’s kingdom and light in the merciful",
    "Writer": "S Robinson, R Shiner",
    "Source": "Exalt",
    "Year": 2014,
    "Ideal Key(s)*": "Em,G",
    "Tempo": 96,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "VCVCC",
    "Style": "Slow,Driving",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We,They",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Come people of the risen king",
    "Key words": "unity,church,praise",
    "Themes": "Unity,church,praise",
    "Function": "Declaration",
    "Function/Emotion": "D: Call to worship, invitation",
    "Writer": "Townend, Getty",
    "Source": "Thankyou",
    "Year": 2007,
    "Ideal Key(s)*": "Bb",
    "Tempo": 108,
    "Time signature": "4/4",
    "Range": 11,
    "Structure": "VCVCVC",
    "Style": "Upbeat,Driving",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Come thou fount",
    "Key words": "praise,grace,faithfulness,wandering",
    "Themes": "Praise,grace,faithfulness,wandering",
    "Function": "Declaration,Response,Preparation",
    "Function/Emotion": "D: Praise, P/R: (Pledge)",
    "Writer": "Robinson, Wyeth",
    "Source": "Hymn",
    "Year": "1700s",
    "Ideal Key(s)*": "Bb,B,C",
    "Tempo": 72,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "V1-4",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Come you saints",
    "Key words": "election,grace,salvation,heaven",
    "Themes": "Election,grace,salvation,heaven",
    "Function": "Declaration",
    "Function/Emotion": "D: Reason to gather, expression of unity",
    "Writer": "Baird",
    "Source": "Sovereign Grae",
    "Year": 2004,
    "Ideal Key(s)*": "E,F",
    "Tempo": 64,
    "Time signature": "6/8",
    "Range": 9,
    "Structure": "VVV",
    "Style": "Opener",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Come you thirsty",
    "Key words": "contentment,trust,comfort",
    "Themes": "Contentment,trust,comfort",
    "Function": "Response",
    "Function/Emotion": "R: Comfort, trust, assurance, need",
    "Writer": "L Gordon",
    "Source": "Exalt",
    "Year": 2012,
    "Ideal Key(s)*": "Bb,B,C",
    "Tempo": 84,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "VVVV",
    "Style": "Slow,Celtic",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Self,Each other",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Cornerstone",
    "Key words": "grace",
    "Themes": "Grace in present and future,darkness",
    "Function": "Declaration",
    "Function/Emotion": "D: Expression of trust in Jesus",
    "Writer": "Myrin et al",
    "Source": "Hillsong",
    "Year": 2011,
    "Ideal Key(s)*": "C,D",
    "Tempo": 72,
    "Time signature": "4/4",
    "Range": "6-Dec",
    "Structure": "VVCVCVC",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Crown him",
    "Key words": "king,love,life,peace,time",
    "Themes": "king of humanity,love,life,peace,time",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Praise of Jesus",
    "Writer": "Elvey, Bridges",
    "Source": "Hymn",
    "Year": "1800s",
    "Ideal Key(s)*": "Bb,C,D",
    "Tempo": 104,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "V1,2,3,4,6",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone,Self",
    "I/we": "I,We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Desert song",
    "Key words": "trials,dryness,provision,refining,praise",
    "Themes": "Trials,dryness,provision,refining,praise",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Joy and worship despite trials",
    "Writer": "Ligertwood",
    "Source": "Hillsong",
    "Year": 2008,
    "Ideal Key(s)*": "D",
    "Tempo": 120,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VVCVCBV",
    "Style": "Moderate",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Rhythm",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Even So Come",
    "Key words": "Jesus' return,church",
    "Themes": "Return of Jesus,church as bride,ready and waiting",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Pledge to be ready for Jesus",
    "Writer": "Tomlin et al",
    "Source": "WT",
    "Year": 2015,
    "Ideal Key(s)*": "D",
    "Tempo": 54,
    "Time signature": "6/8",
    "Range": 11,
    "Structure": "VVCVCBC",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm,Range",
    "Addressed to": "Everyone,God",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "For all you’ve done",
    "Key words": "redemption,joy",
    "Themes": "Redemption,joy",
    "Function": "Declaration",
    "Function/Emotion": "D: Opener",
    "Writer": "Morgan",
    "Source": "Hillsong",
    "Year": 2004,
    "Ideal Key(s)*": "E",
    "Tempo": 132,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VPCVPCPC",
    "Style": "Upbeat",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Rhythm",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Forever",
    "Key words": "God’s love,thanks,praise",
    "Themes": "God’s love,thanks,praise",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise for God’s love and salvation",
    "Writer": "Tomlin",
    "Source": "WT",
    "Year": 2001,
    "Ideal Key(s)*": "E",
    "Tempo": 140,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VVCVCC",
    "Style": "Upbeat",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm,Words hard to read",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Forever Faithful",
    "Key words": "sin,guidance,trust,idols,mercy",
    "Themes": "Sin,guidance,trust,idols,mercy",
    "Function": "Response",
    "Function/Emotion": "R: Confession, expression of trust",
    "Writer": "S Robinson",
    "Source": "Exalt",
    "Year": 2013,
    "Ideal Key(s)*": "C",
    "Tempo": 50,
    "Time signature": "6/8",
    "Range": 10,
    "Structure": "VCVCC",
    "Style": "Reflective,Lilting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "God has spoken",
    "Key words": "God’s word,Spirit,Trinity",
    "Themes": "God’s word,Spirit,Trinity,spoken in history",
    "Function": "Preparation,Declaration",
    "Function/Emotion": "D/P: Reminder",
    "Writer": "Briggs, Beethoven",
    "Source": "Hymn",
    "Year": "1800s",
    "Ideal Key(s)*": "E,F",
    "Tempo": 96,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "V1,2,3",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Church",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "God of Wonders",
    "Key words": "creation,God's holiness",
    "Themes": "Creation,holy God",
    "Function": "Declaration",
    "Function/Emotion": "D: Worship of creator",
    "Writer": "Byrd, Hindalong",
    "Source": "",
    "Year": 2000,
    "Ideal Key(s)*": "F,G",
    "Tempo": 82,
    "Time signature": "4/4",
    "Range": 6,
    "Structure": "VCVC",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Grace Alone",
    "Key words": "grace,election,new creation",
    "Themes": "Grace not works,election,new creation",
    "Function": "Declaration",
    "Function/Emotion": "D: Reminder of grace",
    "Writer": "Kensrue",
    "Source": "Mars Hill",
    "Year": 2013,
    "Ideal Key(s)*": "D",
    "Tempo": 144,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VCVCBC",
    "Style": "Upbeat",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Syncopation",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Great is your faithfulness",
    "Key words": "provision,guidance,faithfulness",
    "Themes": "provision,guidance,faithfulness",
    "Function": "Response",
    "Function/Emotion": "R: Thankfulness",
    "Writer": "Chisholm, Runyan",
    "Source": "Hymn",
    "Year": 1923,
    "Ideal Key(s)*": "Bb,C",
    "Tempo": 92,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "VCVCVC",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Hail the King",
    "Key words": "fulfilment of OT,king,justice,nations",
    "Themes": "Jesus fulfilment of OT,king,justice,nations",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Praise, declaration of Jesus God’s king",
    "Writer": "L Gordon",
    "Source": "Exalt",
    "Year": 2012,
    "Ideal Key(s)*": "F",
    "Tempo": 70,
    "Time signature": "6/8",
    "Range": 8,
    "Structure": "VCVCC",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "He is exalted",
    "Key words": "king,praise,truth,rejoice",
    "Themes": "King,praise,truth,rejoice",
    "Function": "Declaration",
    "Function/Emotion": "D: Simple expression of worship",
    "Writer": "Paris",
    "Source": "",
    "Year": 1985,
    "Ideal Key(s)*": "D,E",
    "Tempo": "150/50",
    "Time signature": "6/8",
    "Range": 9,
    "Structure": "VC",
    "Style": "Retro",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Hear our prayer",
    "Key words": "prayer,faith,kingdom",
    "Themes": "Prayer,faith,kingdom come,seeking God",
    "Function": "Response",
    "Function/Emotion": "R: Pleading, expression of faith",
    "Writer": "Cooper, Judd",
    "Source": "Emu",
    "Year": 2014,
    "Ideal Key(s)*": "Bb",
    "Tempo": 68,
    "Time signature": "4/4",
    "Range": 11,
    "Structure": "VVCVCC",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Here I am to worship",
    "Key words": "Jesus' exaltation,Jesus' humilty,cross",
    "Themes": "God exalted and humbled in Jesus,cross",
    "Function": "Declaration",
    "Function/Emotion": "D: Worship of exalted and humbled God",
    "Writer": "Hughes",
    "Source": "Thankyou",
    "Year": 2000,
    "Ideal Key(s)*": "E",
    "Tempo": 80,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VCVCBC",
    "Style": "Reflective,Uplifting",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Here is Love",
    "Key words": "cross,love,grace,mercy,justice",
    "Themes": "cross,love,grace,mercy,justice",
    "Function": "Response",
    "Function/Emotion": "R: Thankfulness, obedience",
    "Writer": "Rees, Lowry",
    "Source": "Hymn",
    "Year": 1876,
    "Ideal Key(s)*": "E,F",
    "Tempo": 80,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "V1-3",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God,Others",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Holy holy holy",
    "Key words": "worship,glory,trinity",
    "Themes": "worship,glory,trinity",
    "Function": "Declaration",
    "Function/Emotion": "D: Attributes of God",
    "Writer": "Heber, Dykes",
    "Source": "Hymn",
    "Year": "1800s",
    "Ideal Key(s)*": "Bb,C",
    "Tempo": 88,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "V1,3,4",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "How deep the F’s love",
    "Key words": "cross,atonement,love",
    "Themes": "cross,atonement,love,(boasting)",
    "Function": "Response",
    "Function/Emotion": "R: Repentance, thankfulness",
    "Writer": "Townend",
    "Source": "Thankyou",
    "Year": 1995,
    "Ideal Key(s)*": "Eb,E,F",
    "Tempo": 108,
    "Time signature": "5/4",
    "Range": 8,
    "Structure": "V1-3",
    "Style": "Slow,Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "I,We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "How great is our God",
    "Key words": "trinity,majesty,king",
    "Themes": "Characteristics of God: light,trinity,majesty,kingship",
    "Function": "Declaration",
    "Function/Emotion": "D: Expression of God’s character",
    "Writer": "Tomlin, Reeves",
    "Source": "WT",
    "Year": 2004,
    "Ideal Key(s)*": "G",
    "Tempo": 80,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "VCVCBC",
    "Style": "Reflective,Uplifting",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Guitar,Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "How great thou art",
    "Key words": "God’s goodness,creation,atonement,Jesus' return",
    "Themes": "God’s goodness; creation,atonement,Jesus' return",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Praise, thankfulness",
    "Writer": "Boberg, Hine",
    "Source": "Hymn",
    "Year": "1800s",
    "Ideal Key(s)*": "G",
    "Tempo": 112,
    "Time signature": "4/4",
    "Range": 10,
    "Structure": "V1,C,V3,C,V4,C",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God,Others",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "I cannot tell",
    "Key words": "saviour,king",
    "Themes": "story of Jesus,Saviour/King",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Joy in Jesus Saviour of all",
    "Writer": "Fullerton, trad",
    "Source": "Hymn",
    "Year": 1929,
    "Ideal Key(s)*": "C",
    "Tempo": 104,
    "Time signature": "4/4",
    "Range": 12,
    "Structure": "V1-4",
    "Style": "Celtic",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "I have a shelter",
    "Key words": "shelter,rest,peace,trials,refuge,weakness",
    "Themes": "Shelter,rest,peace,trials,refuge,weakness",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Expression of dependence",
    "Writer": "B Kauflin, Cook",
    "Source": "Sovereign Grae",
    "Year": 2008,
    "Ideal Key(s)*": "C",
    "Tempo": 76,
    "Time signature": "3/4",
    "Range": 10,
    "Structure": "VVV",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Jesus,God",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "In Christ Alone",
    "Key words": "incarnation,atonement,resurrection,future",
    "Themes": "Incarnation,atonement,resurrection,future",
    "Function": "Declaration,Preparation",
    "Function/Emotion": "D/P: Assurance, hope",
    "Writer": "Townend, Getty",
    "Source": "Thankyou",
    "Year": 2001,
    "Ideal Key(s)*": "D,Eb",
    "Tempo": 60,
    "Time signature": "3/4",
    "Range": 11,
    "Structure": "V1-4",
    "Style": "Celtic",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Indescribable",
    "Key words": "creation",
    "Themes": "Creation",
    "Function": "Declaration",
    "Function/Emotion": "D: Expresses awe of creator",
    "Writer": "Reeves, Story",
    "Source": "WT",
    "Year": 2004,
    "Ideal Key(s)*": "D,E",
    "Tempo": 60,
    "Time signature": "6/8",
    "Range": 5,
    "Structure": "VCVCIC",
    "Style": "Driving",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "It is well",
    "Key words": "sorrow,atonement,hope,Jesus’s return",
    "Themes": "sorrow,atonement,hope,J’s return",
    "Function": "Response",
    "Function/Emotion": "R: Assurance, comfort, hope",
    "Writer": "Spafford, Bliss",
    "Source": "Hymn",
    "Year": "1800s",
    "Ideal Key(s)*": "A,Bb",
    "Tempo": 92,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "V1CV2CV3CV5/6C",
    "Style": "Emotional",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Jesus paid it all",
    "Key words": "weakness,trust,forgiveness,transformation",
    "Themes": "weakness,trust,forgiveness,transformation",
    "Function": "Response",
    "Function/Emotion": "R: Assurance, trust, strength",
    "Writer": "Hall, Grape",
    "Source": "Hymn",
    "Year": 1865,
    "Ideal Key(s)*": "C",
    "Tempo": 72,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "V1-4",
    "Style": "Varies",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Jesus thank you",
    "Key words": "forgiveness,thanksgiving,grace",
    "Themes": "Forgiveness,thanksgiving,grace",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Thanksgiving for forgiveness",
    "Writer": "P Sczebel",
    "Source": "Sovereign Grae",
    "Year": 2003,
    "Ideal Key(s)*": "G",
    "Tempo": 130,
    "Time signature": "4/4",
    "Range": 11,
    "Structure": "VCVCBC",
    "Style": "Pledge",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Range,Rhythm",
    "Addressed to": "Jesus,God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Just as I am",
    "Key words": "mercy,sin,atonement,cleansing",
    "Themes": "Mercy,sin,atonement,cleansing",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Expression of trust in Jesus’s mercy",
    "Writer": "J Bargerbos",
    "Source": "Exalt",
    "Year": 2014,
    "Ideal Key(s)*": "Bb,F#m,A",
    "Tempo": 100,
    "Time signature": "3/4",
    "Range": 11,
    "Structure": "VVCVCC",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Just as I am (new)",
    "Key words": "",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "Bargerbos",
    "Source": "Exalt",
    "Year": 2014,
    "Ideal Key(s)*": "F#m,A",
    "Tempo": 100,
    "Time signature": "3/4",
    "Range": 11,
    "Structure": "VVCVCC",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Just as I am (old)",
    "Key words": "grace,sin,fear,doubt,atonement",
    "Themes": "grace in sin,fear,doubt,atonement",
    "Function": "Response,Preparation",
    "Function/Emotion": "P/R: Dependence, confession",
    "Writer": "Elliot,Bradbury",
    "Source": "Hymn",
    "Year": "C19th",
    "Ideal Key(s)*": "C",
    "Tempo": 92,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "V1,3,4",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Let your kingdom come",
    "Key words": "evangelism,kingdom,mission,grace",
    "Themes": "Evangelism,kingdom,mission,grace",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Prayer for action",
    "Writer": "B Kauflin",
    "Source": "Sovereign Grae",
    "Year": 2006,
    "Ideal Key(s)*": "F,G",
    "Tempo": 120,
    "Time signature": "4/4",
    "Range": 10,
    "Structure": "VCVCC",
    "Style": "Upbeat,Inspiring",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Pitch,Rhythm",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Lift up your heads",
    "Key words": "king,Jesus' return",
    "Themes": "leads his people in glory,King,Jesus' return",
    "Function": "Declaration",
    "Function/Emotion": "D: Joy in Jesus’s victory, return",
    "Writer": "Morrow",
    "Source": "Emu",
    "Year": 2007,
    "Ideal Key(s)*": "F,G",
    "Tempo": 57,
    "Time signature": "6/8",
    "Range": 8,
    "Structure": "VCVCVC",
    "Style": "Moderate,Driving",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "They",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Man of sorrows",
    "Key words": "cross,salvation,sacrifice,atonement,praise",
    "Themes": "cross,salvation,sacrifice,atonement,praise",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Honour of Jesus’s sacrifice",
    "Writer": "Ligertwood, Crocker",
    "Source": "Hillsong",
    "Year": 2012,
    "Ideal Key(s)*": "Bb,B,C",
    "Tempo": 80,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VVCVCBVC",
    "Style": "Moving",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone,God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Man of Sorrows (old)",
    "Key words": "saviour,cross,atonement,king",
    "Themes": "Saviour,cross,atonement,king",
    "Function": "Response",
    "Function/Emotion": "R: Sorrow and joy of cross",
    "Writer": "Bliss",
    "Source": "Hymn",
    "Year": 1875,
    "Ideal Key(s)*": "G,A",
    "Tempo": 76,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "V1-5",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "I,We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "May the mind (new)",
    "Key words": "",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "Peterson",
    "Source": "Emu",
    "Year": 1994,
    "Ideal Key(s)*": "D,E",
    "Tempo": 120,
    "Time signature": "4/4",
    "Range": 6,
    "Structure": "",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "May the mind (old)",
    "Key words": "obedience,mind,word,peace,love,race",
    "Themes": "obedience: mind,word,peace,love,race",
    "Function": "Response",
    "Function/Emotion": "R: Obedience",
    "Writer": "Gould,Wilkinsn",
    "Source": "Hymn",
    "Year": 1913,
    "Ideal Key(s)*": "C",
    "Tempo": 96,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "V1-5",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Merciful God",
    "Key words": "confession,forgiveness,cleansing,obedience",
    "Themes": "Confession,forgiveness,cleansing,obedience",
    "Function": "Preparation",
    "Function/Emotion": "P: Confession, prayer",
    "Writer": "L Gordon",
    "Source": "Exalt",
    "Year": 2010,
    "Ideal Key(s)*": "Bb",
    "Tempo": 126,
    "Time signature": "3/4",
    "Range": 11,
    "Structure": "VCVC",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Mighty to save",
    "Key words": "forgiveness,surrender,salvation",
    "Themes": "Forgiveness,surrender,salvation",
    "Function": "Declaration",
    "Function/Emotion": "D: General",
    "Writer": "Morgan, Fielding",
    "Source": "Hillsong",
    "Year": 2006,
    "Ideal Key(s)*": "F,G",
    "Tempo": 76,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VCVCBC",
    "Style": "Moderate,Builds",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Rhythm",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "My chains",
    "Key words": "",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "Tomlin etc",
    "Source": "WT",
    "Year": 2006,
    "Ideal Key(s)*": "D",
    "Tempo": 120,
    "Time signature": "4/4",
    "Range": 11,
    "Structure": "vvcvvcc",
    "Style": "",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "My hope is built (new",
    "Key words": "",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "Chiswell",
    "Source": "Emu",
    "Year": 1992,
    "Ideal Key(s)*": "D",
    "Tempo": 120,
    "Time signature": "4/4",
    "Range": 11,
    "Structure": "",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Hard",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "My hope is built (old)",
    "Key words": "hope,grace,merit,steadfastness",
    "Themes": "hope,grace,merit,steadfastness",
    "Function": "Response,Declaration",
    "Function/Emotion": "D/R: Sure hope in uncertainty of life",
    "Writer": "Mote, Bradbury",
    "Source": "Hymn",
    "Year": 1834,
    "Ideal Key(s)*": "E",
    "Tempo": 80,
    "Time signature": "3/4",
    "Range": 9,
    "Structure": "V1-4",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Never Alone",
    "Key words": "God come near,salvation",
    "Themes": "God come near in Jesus’s death and resurrection",
    "Function": "Response",
    "Function/Emotion": "R: Joy and security in Jesus",
    "Writer": "Richardson, Percival",
    "Source": "Emu",
    "Year": 2006,
    "Ideal Key(s)*": "C,D,E",
    "Tempo": 84,
    "Time signature": "4/4",
    "Range": 6,
    "Structure": "V1-4",
    "Style": "Moderate",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "No other name",
    "Key words": "salvation,strength,joy,victory",
    "Themes": "Salvation,strength,joy,victory only in Jesus",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Joy and hope in Jesus’s salvation",
    "Writer": "Hodge",
    "Source": "Emu",
    "Year": 2010,
    "Ideal Key(s)*": "Bb",
    "Tempo": 65,
    "Time signature": "4/4",
    "Range": 11,
    "Structure": "VCVCVC",
    "Style": "Moderate,Driving",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I,We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "O church arise",
    "Key words": "church,battle,love,faith,strength,glory,victory",
    "Themes": "Church,battle,love,faith,strength,glory,victory",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Call to worship, perseverance, victory",
    "Writer": "Townend, Getty",
    "Source": "Thankyou",
    "Year": 2005,
    "Ideal Key(s)*": "D",
    "Tempo": 58,
    "Time signature": "3/4",
    "Range": 11,
    "Structure": "V1-4",
    "Style": "Celtic",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "O for 1000 (new)",
    "Key words": "",
    "Themes": "",
    "Function": "Response",
    "Function/Emotion": "R: Proclamation",
    "Writer": "Crowder?",
    "Source": "Hymn",
    "Year": "",
    "Ideal Key(s)*": "E,F",
    "Tempo": 112,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "O for 1000 (old)",
    "Key words": "life of Jesus,joy,praise,goodness",
    "Themes": "Life of Jesus,joyful praise,declaration of goodness",
    "Function": "Declaration",
    "Function/Emotion": "D: Joyful praise",
    "Writer": "Wesley, Jarman",
    "Source": "Hymn",
    "Year": "C18th",
    "Ideal Key(s)*": "E,F",
    "Tempo": 132,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "V1-6",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "O Great God",
    "Key words": "sin,Spirit,gospel,obedience",
    "Themes": "Sin,Spirit,gospel,obedience",
    "Function": "Response",
    "Function/Emotion": "R: Thanksgiving for salvation, prayer for obedience",
    "Writer": "B Kauflin",
    "Source": "Sovereign Grae",
    "Year": 2006,
    "Ideal Key(s)*": "C",
    "Tempo": 72,
    "Time signature": "3/4",
    "Range": 10,
    "Structure": "VVV",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "O praise the name",
    "Key words": "Jesus' death,resurrection,Jesus' return",
    "Themes": "Jesus death,resurrection and return",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise and declaration of gospel",
    "Writer": "Sampson et al",
    "Source": "Hillsong",
    "Year": 2015,
    "Ideal Key(s)*": "G",
    "Tempo": 72,
    "Time signature": "4/4",
    "Range": 12,
    "Structure": "VVCVCVC",
    "Style": "Slow,Builds",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm,Range",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "One heart, one people",
    "Key words": "unity,church,gathering",
    "Themes": "Unity,church,gathering",
    "Function": "Declaration",
    "Function/Emotion": "D: Expression of unity in gathering",
    "Writer": "L Gordon",
    "Source": "Exalt",
    "Year": 2016,
    "Ideal Key(s)*": "F,G",
    "Tempo": 108,
    "Time signature": "4/4",
    "Range": 6,
    "Structure": "VCVCBC",
    "Style": "Upbeat,Opener",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Only a holy God",
    "Key words": "God's holiness,God's glory,power,Father",
    "Themes": "Holy God,majesty,glory,power,Father",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Worship of holy and personal God",
    "Writer": "Smith et al",
    "Source": "City Alight",
    "Year": 2016,
    "Ideal Key(s)*": "D",
    "Tempo": "150/50",
    "Time signature": "3/4",
    "Range": 9,
    "Structure": "VVCVCVC",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We,I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Onwards & Upwards",
    "Key words": "faith,evangelism",
    "Themes": "Philippians,continuing in faith,evangelism",
    "Function": "Declaration",
    "Function/Emotion": "D: Encouraging each other to continue",
    "Writer": "L Gordon",
    "Source": "Exalt",
    "Year": 2007,
    "Ideal Key(s)*": "F,G",
    "Tempo": 96,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VVCVVCBC",
    "Style": "Upbeat",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Praise to the Lord",
    "Key words": "praise,church,sustains,shelter",
    "Themes": "Praise,church,sustains,shelter",
    "Function": "Declaration",
    "Function/Emotion": "D: Call to worship",
    "Writer": "Neander, Winkworth",
    "Source": "Hymn",
    "Year": "C19th",
    "Ideal Key(s)*": "Eb,E",
    "Tempo": 132,
    "Time signature": "3/4",
    "Range": 9,
    "Structure": "V1,2,3,5",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Self,Church",
    "I/we": "We,I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Psalm 96",
    "Key words": "saviour,judge",
    "Themes": "God worthy of worship as saviour and judge",
    "Function": "Declaration",
    "Function/Emotion": "D: Worship, declaration",
    "Writer": "McDonald",
    "Source": "Emu",
    "Year": 1987,
    "Ideal Key(s)*": "D,E",
    "Tempo": 84,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "VVCVCC",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Refuge",
    "Key words": "",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "",
    "Source": "",
    "Year": "",
    "Ideal Key(s)*": "",
    "Tempo": "",
    "Time signature": "",
    "Range": "",
    "Structure": "",
    "Style": "",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Resurrection hymn",
    "Key words": "resurrection",
    "Themes": "Resurrection of Jesus and his people",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Assurance, victory, hope",
    "Writer": "Townend, Getty",
    "Source": "Thankyou",
    "Year": 2003,
    "Ideal Key(s)*": "D",
    "Tempo": 92,
    "Time signature": "12/8",
    "Range": 11,
    "Structure": "V1-3",
    "Style": "Lilting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Revelation song",
    "Key words": "God's holiness,power,king",
    "Themes": "Holy God,powerful,Jesus as King (Revelation 4,5)",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise of all powerful God and Lamb",
    "Writer": "Riddle",
    "Source": "Gateway",
    "Year": 2004,
    "Ideal Key(s)*": "C,D",
    "Tempo": 64,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VVC",
    "Style": "Builds",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Words hard to read",
    "Addressed to": "Everyone,God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Rock of Ages (new)",
    "Key words": "",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "Buchanan",
    "Source": "AFES",
    "Year": "",
    "Ideal Key(s)*": "Bb,B",
    "Tempo": 60,
    "Time signature": "6/8",
    "Range": 10,
    "Structure": "V1-4",
    "Style": "Uplifting",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Rock of ages (old)",
    "Key words": "guilt,judgment,grace,mercy",
    "Themes": "Guilt,judgment,grace,mercy",
    "Function": "Response,Preparation",
    "Function/Emotion": "P, R: Confession, absolution",
    "Writer": "Toplady",
    "Source": "Hymn",
    "Year": "C18th,?",
    "Ideal Key(s)*": "G",
    "Tempo": 72,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "V1-4",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Salvation belongs to our God",
    "Key words": "salvation,praise,glory,redeemed,unity",
    "Themes": "Salvation,praise,glory,redeemed,unity",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise, unity",
    "Writer": "Howard, Turner",
    "Source": "",
    "Year": 1985,
    "Ideal Key(s)*": "F,G",
    "Tempo": "",
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VCVC",
    "Style": "Retro",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "See him coming",
    "Key words": "praise,king,Jesus' return",
    "Themes": "Praise of Jesus as living and returning King",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise of Jesus, anticipating his return",
    "Writer": "Peterson",
    "Source": "Emu",
    "Year": 2003,
    "Ideal Key(s)*": "C",
    "Tempo": 92,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VVCVCBC",
    "Style": "Driving",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Speak O Lord",
    "Key words": "word,truth,obedience,humility",
    "Themes": "Word,truth,obedience,humility",
    "Function": "Preparation",
    "Function/Emotion": "P: Prep for word, obedience",
    "Writer": "Townend, Getty",
    "Source": "Thankyou",
    "Year": 2005,
    "Ideal Key(s)*": "Bb,B,C",
    "Tempo": 72,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "V1-3",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Take my life (new)",
    "Key words": "",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "Buchanan",
    "Source": "AFES",
    "Year": "",
    "Ideal Key(s)*": "C",
    "Tempo": 72,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "V1-6",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Take my life (old)",
    "Key words": "obedience,service,speech,money,mind,love",
    "Themes": "Obedience; service,speech,money,mind,love",
    "Function": "Response",
    "Function/Emotion": "R: Obedience, surrender?",
    "Writer": "Havergal,",
    "Source": "Hymn",
    "Year": "C19th, ?",
    "Ideal Key(s)*": "F",
    "Tempo": 100,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "V1-6",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "The Chorus of the Saved",
    "Key words": "praise,salvation,drawing near",
    "Themes": "Praise,salvation,drawing near",
    "Function": "Declaration",
    "Function/Emotion": "D: Call to praise Jesus",
    "Writer": "Hodge",
    "Source": "Emu",
    "Year": 2014,
    "Ideal Key(s)*": "Bb",
    "Tempo": 100,
    "Time signature": "4/4",
    "Range": 11,
    "Structure": "VVCVCBC",
    "Style": "Upbeat",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Range",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "The Day will come",
    "Key words": "Jesus’s return",
    "Themes": "Jesus’s return",
    "Function": "Declaration",
    "Function/Emotion": "D: Personal knowledge of returning saviour",
    "Writer": "Peterson",
    "Source": "Emu",
    "Year": 2007,
    "Ideal Key(s)*": "Am",
    "Tempo": 88,
    "Time signature": "4/4",
    "Range": 10,
    "Structure": "VCVCC",
    "Style": "Atmospheric",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Syncopation",
    "Addressed to": "Everyone",
    "I/we": "We,I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "The perfect wisdom",
    "Key words": "wisdom,creation,salvation",
    "Themes": "Wisdom in creation,salvation and life",
    "Function": "Response,Preparation",
    "Function/Emotion": "P/R: Reflection, assurance, comfort",
    "Writer": "Townend, Getty",
    "Source": "Thankyou",
    "Year": 2011,
    "Ideal Key(s)*": "Bb",
    "Tempo": 68,
    "Time signature": "¾",
    "Range": 9,
    "Structure": "V1-3",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "The power of the cross",
    "Key words": "cross,forgiveness,atonement,resurrection",
    "Themes": "cross,forgiveness,atonement,resurrection",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Confession, absolution, thanksgiving",
    "Writer": "Townend, Getty",
    "Source": "Thankyou",
    "Year": 2005,
    "Ideal Key(s)*": "Bb",
    "Tempo": 76,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "VCVCVCVC",
    "Style": "Reflective,Moderate",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "The Servant King",
    "Key words": "servant,cross,love,obedience,serving",
    "Themes": "Jesus servant,cross,love,respond in obedience,serving others",
    "Function": "Response",
    "Function/Emotion": "R: Thankfulness, obedience, serving others",
    "Writer": "Kendrick",
    "Source": "Thankyou",
    "Year": 1983,
    "Ideal Key(s)*": "Eb",
    "Tempo": 65,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "VC x4",
    "Style": "Retro",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God,Others",
    "I/we": "I,We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "The steadfast love",
    "Key words": "love,mercies,faithfulness",
    "Themes": "Love,mercies,faithfulness",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Good add-on to another song",
    "Writer": "McNeill",
    "Source": "",
    "Year": 1974,
    "Ideal Key(s)*": "D,E",
    "Tempo": 80,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "C",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We,I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Thine be the glory",
    "Key words": "resurrection,victory",
    "Themes": "Resurrection,victory",
    "Function": "Declaration",
    "Function/Emotion": "D: Confidence through death",
    "Writer": "Budry, Handel",
    "Source": "Hymn",
    "Year": "C18th",
    "Ideal Key(s)*": "D",
    "Tempo": 100,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "V1-3",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "This I Believe",
    "Key words": "creation,gospel,trinity",
    "Themes": "Creation,gospel,trinity",
    "Function": "Declaration",
    "Function/Emotion": "D: Declaration of faith",
    "Writer": "Crocker, Fielding",
    "Source": "Hillsong",
    "Year": 2014,
    "Ideal Key(s)*": "F,G",
    "Tempo": 76,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VCVCBCC",
    "Style": "Slow,Builds",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Rhythm",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "This is amazing grace",
    "Key words": "king,grace,praise",
    "Themes": "King,grace,praise",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise",
    "Writer": "Wickham, Riddle",
    "Source": "Bethel",
    "Year": 2012,
    "Ideal Key(s)*": "E,F",
    "Tempo": 108,
    "Time signature": "4/4",
    "Range": 6,
    "Structure": "VVCVVCBC",
    "Style": "Upbeat,Relaxed",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Rhythm",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "This is our God",
    "Key words": "God’s love,dependence,worship,gospel",
    "Themes": "God’s love,dependence,worship,gospel",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Prayer for help, worship, dependence",
    "Writer": "Morgan",
    "Source": "Hillsong",
    "Year": 2008,
    "Ideal Key(s)*": "E",
    "Tempo": 76,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VCVCBC",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "Rhythm",
    "Addressed to": "God",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "This life I live",
    "Key words": "sin,repentance,salvation",
    "Themes": "Sin,repentance,salvation",
    "Function": "Response",
    "Function/Emotion": "R: Obedience, living for Jesus not self",
    "Writer": "Morrow",
    "Source": "Emu",
    "Year": 2009,
    "Ideal Key(s)*": "Bb,B,C",
    "Tempo": 68,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "VVV",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Self,Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "To God be the glory",
    "Key words": "victory,resurrection",
    "Themes": "Victory over death,resurrection",
    "Function": "Declaration",
    "Function/Emotion": "D: Victory, hope",
    "Writer": "Crosby, Doane",
    "Source": "Hymn",
    "Year": 1875,
    "Ideal Key(s)*": "F,G",
    "Tempo": 104,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "VCVCVC",
    "Style": "Straight",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Turn your eyes upon Jesus",
    "Key words": "God's glory,grace",
    "Themes": "Jesus’s glory and grace",
    "Function": "Declaration,Preparation",
    "Function/Emotion": "D/P: Good add-on to another song or prep",
    "Writer": "Lemmel",
    "Source": "New Spring",
    "Year": 1922,
    "Ideal Key(s)*": "C,D,Eb",
    "Tempo": 84,
    "Time signature": "3/4",
    "Range": 6,
    "Structure": "C",
    "Style": "Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "We,I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "Waiting for the day",
    "Key words": "Jesus' return,faith,trust",
    "Themes": "Jesus' return,faith and sight,meeting Jesus,trust",
    "Function": "Response",
    "Function/Emotion": "R: Expression of desire to meet Jesus, comfort",
    "Writer": "L Gordon",
    "Source": "Exalt",
    "Year": 2009,
    "Ideal Key(s)*": "D",
    "Tempo": 84,
    "Time signature": "2/2",
    "Range": 9,
    "Structure": "VCVCBC",
    "Style": "Reflective,Uplifting",
    "Difficulty rating (vocal)": "Moderate",
    "What makes it difficult": "",
    "Addressed to": "God,Each other",
    "I/we": "I,We",
    "Driver": "Piano",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "We belong to the day",
    "Key words": "Jesus' return,judgement,salvation,evangelism",
    "Themes": "Jesus' return,light,judgement,salvation,evangelism,bride",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Sober judgment, mission, salvation",
    "Writer": "Morrow",
    "Source": "Emu",
    "Year": 2006,
    "Ideal Key(s)*": "C#m,E",
    "Tempo": 124,
    "Time signature": "4/4",
    "Range": 8,
    "Structure": "VVCVCBC",
    "Style": "Upbeat",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "Syncopation",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "What a friend",
    "Key words": "prayer,refuge,comfort",
    "Themes": "Prayer,friend,refuge,solace",
    "Function": "Declaration,Response",
    "Function/Emotion": "D/R: Comfort, refuge",
    "Writer": "Scriven, Converse",
    "Source": "Hymn",
    "Year": 1868,
    "Ideal Key(s)*": "E",
    "Tempo": 84,
    "Time signature": "4/4",
    "Range": 9,
    "Structure": "V1-3",
    "Style": "Relaxed",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Each other",
    "I/we": "We",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "What the Lord has done in me",
    "Key words": "conversion,weakness,cleansing,declaration",
    "Themes": "Conversion,weakness,cleansing,declaration",
    "Function": "Declaration",
    "Function/Emotion": "D: Praise and declaration of gospel",
    "Writer": "Morgan",
    "Source": "Hillsong",
    "Year": 1998,
    "Ideal Key(s)*": "C",
    "Tempo": 70,
    "Time signature": "3/4",
    "Range": 10,
    "Structure": "VVCVVC",
    "Style": "Slow",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "Everyone",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "When I survey",
    "Key words": "cross,sacrifice,love",
    "Themes": "cross,sacrifice,love",
    "Function": "Response",
    "Function/Emotion": "R: Thankfulness, response to love",
    "Writer": "Watts, Miller",
    "Source": "Hymn",
    "Year": "C18th",
    "Ideal Key(s)*": "C",
    "Tempo": 88,
    "Time signature": "3/4",
    "Range": 8,
    "Structure": "V1-4",
    "Style": "Straight,Reflective",
    "Difficulty rating (vocal)": "Easy",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "I",
    "Driver": "Piano,Guitar",
    "Core": "checked",
    "Version": 1
  },
  {
    "Title": "",
    "Key words": "Jesus' humilty",
    "Themes": "",
    "Function": "",
    "Function/Emotion": "",
    "Writer": "",
    "Source": "",
    "Year": "",
    "Ideal Key(s)*": "",
    "Tempo": "",
    "Time signature": "",
    "Range": "",
    "Structure": "",
    "Style": "",
    "Difficulty rating (vocal)": "",
    "What makes it difficult": "",
    "Addressed to": "",
    "I/we": "",
    "Driver": "",
    "Core": "",
    "Version": ""
  }
]
